module.exports = __webpack_public_path__ + "media/images/goals-5 2-1f6a1a075d5066cf89f6d98d815dd16c.jpg";